module.exports = __webpack_public_path__ + "fonts/fontc.db36cf6f.ttf";